import React from 'react';
import PropTypes from 'prop-types';
import Translation from '../../../../../translation/translation';
import getTranslatedText from '../../../../../../helper/get_translated_text';

function LightboxViewAction({ onCloseClick, onSaveClick, disabled }) {
    return (
        <div className="lightbox-filter-view__actions-section lightbox-filters-actions">

            <button
                className="lightbox-filters-actions__action lightbox-filters-actions__close"
                onClick={onCloseClick}
            >
                {getTranslatedText('catalog-filter-lightbox-close-button')}
            </button>

            <button
                className="lightbox-filters-actions__action lightbox-filters-actions__save"
                onClick={onSaveClick}
                disabled={disabled}
            >
                {getTranslatedText('catalog-filter-lightbox-save-button')}
            </button>
        </div>
    );
}

LightboxViewAction.propTypes = {
    onCloseClick: PropTypes.func.isRequired,
    onSaveClick: PropTypes.func.isRequired,
    disabled: PropTypes.bool.isRequired
};
LightboxViewAction.defaultProps = {
    disabled: false
};

export { LightboxViewAction };
